module.exports = __webpack_public_path__ + "img/icon_menu_certificacion_discipline.fe877122.svg";